import { render, staticRenderFns } from "./TeamTarget.vue?vue&type=template&id=4f4b90e3&scoped=true"
import script from "./TeamTarget.vue?vue&type=script&lang=js"
export * from "./TeamTarget.vue?vue&type=script&lang=js"
import style0 from "./TeamTarget.vue?vue&type=style&index=0&id=4f4b90e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b90e3",
  null
  
)

export default component.exports